<template>
  <div class="-the-tree authTree h380">
    <el-input placeholder="住户名称" v-model="filterText"
                  class="margin-bottom-4" size="small" />
    <el-tree ref="authTree" default-expand-all
             :data="tree"
             node-key="id"
             show-checkbox
             :check-strictly="true"
             :expand-on-click-node="false"
             :filter-node-method="filterNode"
             @check-change="changeAuthData">
    </el-tree>>
  </div>
</template>

<script>
  export default {
    name: 'auth-tree',
    props: {
      // filterKey: {
      //   type: String,
      //   default: ''
      // },
      title: {
        type: String,
        default: '标题'
      },
      keyName: {
        type: String,
        default: '键名'
      },
      showPopBox: {
        type: Boolean,
        default: true
      },
      maxDepth: {
        type: Number,
        default: 4
      },
      options: {
        type: Object,
        default () {
          return {
            1: [],
            2: ['add'],
            3: ['add', 'patch', 'delete'],
            4: ['patch', 'delete']
          }
        }
      },
      update: {
        type: Object,
        default () {
          return {
            render: () => [],
          }
        }
      }
    },
    data () {
      return {
        tree: [],
        showDev: false,
        treeData: [],
        treeFromServer: [],
        filterText: '',
        detailForm: {
          title: '添加营业单位',
          show: false,
          then: () => {
          },
          type: ''
        },
        adsStr: [],
        depStr: []
      }
    },
    created () {
      this.render()
    },
    methods: {
      filterNode (value, data) {
        if (!value) return true
        return data._label.indexOf(value) !== -1
      },
      render () {
        this.update.render()
          .then((list) => {
            this.treeData = list
            this.convertData()
          })
      },

      convertData () {
        /**
         * 组装节点
         * @function
         * @param nodes
         */
        const packNode = (nodes) => {
          const getNodes = nodeId =>
            this.treeData.filter(n => n.parentCode === nodeId)

          nodes.forEach(node => {
            const children = getNodes(node.code)
            node.children = children
            if (children.length > 0) {
              return packNode(children)
            }
          })
        }
        /**
         * 格式化原始数据
         */
        this.treeData
          .forEach(it => {
            it.edidable = false
            it.label = it._label
          })

        /**
         * 生成顶层节点
         */
        const tree = this.treeData.filter(tree => tree.parentCode == 0)
        /**
         * 开始组装节点
         */
        packNode(tree)

        this.tree = tree
      },

      changeAuthData (data, checked, indeterminate) {
        if (checked) {
          if (data.code) {
            this.depStr.push(data.code)
          } else {
            this.adsStr.push(data.personCode)
          }
        } else {
          if (data.code) {
            for (let i = 0; i < this.depStr.length; i++) {
              if (this.depStr[i] === data.code) {
                this.depStr.splice(i, 1)
              }
            }
          } else {
            for (let j = 0; j < this.adsStr.length; j++) {
              if (this.adsStr[j] === data.personCode) {
                this.adsStr.splice(j, 1)
              }
            }
          }
        }
        window.sessionStorage.setItem('changeAuthAds', this.adsStr)
        window.sessionStorage.setItem('changeAuthDep', this.depStr)
      }
    },

    watch: {
      filterText (val) {
        this.$refs.authTree.filter(val)
      }
    }
  }
</script>

<style scoped>
  .el-tree{
    height: 320px!important;
    overflow-y: auto;
  }
</style>

<style lang="less">
  .authTree .el-tree-node > .el-tree-node__children {
    overflow: hidden;
  }

  .h380 {
    height: 380px!important;
  }

  .-the-tree {
    .item {
      flex: 1;
      display: flex;
      align-items: center;
      justify-content: space-between;
      font-size: 14px;
      padding-right: 8px;
    }
    .el-icon-damai-ren111, .el-icon-damai-biaoshilei_menjin{
      float: left;
      line-height: 25px;
      font-size: 14px;
      margin-right: 3px;
    }
    .authLeft {
      display: block;
      float: left;
      min-width: 200px;
      max-width: 300px;
      overflow: hidden!important;
      text-overflow: ellipsis;
      white-space: nowrap;
      user-select: none;
    }
    .icon-more {
      display: block;
      font-size: 12px;
      color: #999999;
      position: relative;
      padding: 4px;
      overflow: visible;
      margin-right: 60px;
      .pop-box {
        display: none;
        background-color: #fff;
        width: 48px;
        position: absolute;
        top: 10px;
        left: 20px;
        user-select: none;
        z-index: 2018;
      }
      .operate {
        display: none;
        font-size: 12px;
        color: #999999;
        padding: 5px;
        margin-top: -1px;
        border: 1px solid #999999;
      }
      .operate:hover {
        color: #1362FF;
        border: 1px solid #1362FF;
      }
      &.show .pop-box {
        display: block !important;
        .operate {
          display: block !important;
        }
      }
    }
  }
  label {
    margin-bottom: 0 !important;
  }
  .el-dialog__body {
    .el-input__inner {
      width: 100%;
    }
  }
  .paging {
    float: right;
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 18px;
    padding-right: 8px;
  }
  .authTree {
    .el-tree-node__content {
      cursor: auto;
    }
    .authLeft:hover {
      cursor: pointer;
    }
    .pagePre {
      color: #999999;
    }
    .pagePre:hover {
      cursor: pointer;
      color: #1362FF;
    }
    .pageNext {
      color: #999999;
    }
    .pageNext:hover {
      cursor: pointer;
      color: #1362FF;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/common/auth-tree.vue